export default "__VITE_ASSET__Bm_tmb_U__"